import type { FC } from 'react';
import { Typography } from '@mui/material';

import {
	TRideHailingTriggerSource,
	TripTypeEnum,
	VehicleType,
} from '@mopla/data-models';
import { useTranslation } from '@mopla/i18';

import SearchIcon from '../../icons/SearchOutlinedThinIcon.svg';
import { IVehicleIconProps, VehicleIcon } from '../../icons/Vehicles';

import { LinkStyled, SearchBarContent } from './styled';

export interface ISearchRideLinkButtonProps {
	className?: string;
	onClick?: () => void;
	testId?: string;
}

const TRIGGER_SOURCE_SEARCH_BAR: TRideHailingTriggerSource = 'searchBar';
const VEHICLES: IVehicleIconProps[] = [
	{ mode: TripTypeEnum.PRODT, vehicleType: VehicleType.ECONOMY, size: 's' },
	{ mode: TripTypeEnum.LBODTFLEX, size: 's' },
	{ mode: TripTypeEnum.LBT, size: 's' },
];

export const SearchRideLinkButton: FC<ISearchRideLinkButtonProps> = ({
	className,
	onClick,
	testId = 'homeSearchBar-searchRide-button',
}) => {
	const { t } = useTranslation('common');

	return (
		<LinkStyled
			className={className}
			to="search"
			state={{ triggerSource: TRIGGER_SOURCE_SEARCH_BAR }}
			onClick={onClick}
			data-testid={testId}
		>
			<SearchBarContent gap={0.5}>
				<SearchIcon />
				<Typography variant="bu1-m" color="inherit">
					{t('button.search_ride')}
				</Typography>
			</SearchBarContent>
			<SearchBarContent gap={1}>
				{VEHICLES.map((vehicle, index) => (
					<VehicleIcon
						key={index}
						{...vehicle}
						data-testid={`homeSearchBar-vehicle-${vehicle.mode}-icon`}
					/>
				))}
			</SearchBarContent>
		</LinkStyled>
	);
};
